import { BatchesService } from '@festina/collcalc-general-types/collcalc/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitCollCalcBatch = () =>
  useFestinaMutation({
    component: 'collCalc',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
